// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__q-Zx2","main_title":"Banner_main_title__JoGJM","main_subtitle":"Banner_main_subtitle__gg+We","bannerImage":"Banner_bannerImage__RvjCM"};